export const checkIfSnapshotModeNotificationNeedsToBeReset = (state, action) => {
    const isEnteringSnapshotMode = state.strategy.sourceId !== action.payload.sourceId
    const isAnotherSnapshotCreator = state.strategy.snapshotCreatorId !== action.payload.snapshotCreatorId
    const isAnotherSnapshotNote = state.strategy.snapshotNote !== action.payload.snapshotNote

    return isEnteringSnapshotMode || isAnotherSnapshotCreator || isAnotherSnapshotNote
}
